import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyDpIFs9456JIobouGi7sDz0MROnHR8Oja0',
  authDomain: 'oareauth.firebaseapp.com',
  projectId: 'oareauth',
  storageBucket: 'oareauth.appspot.com',
  messagingSenderId: '69358515492',
  appId: '1:69358515492:web:8e792c4448147887e9afb1',
  measurementId: 'G-59Z6RJEKYC',
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

// Local development points auth at the Firebase Auth emulator so signing up and
// logging in never touch the shared Firebase project. The URL is the browser's
// view of the emulator (a host port), not the container's, and this has to run
// before anything else uses `auth`. Only the dev server honors the variable, so
// a production build never talks to an emulator even if it is set.
const authEmulatorUrl = import.meta.env.VUE_APP_FIREBASE_AUTH_EMULATOR_URL;
if (import.meta.env.DEV && authEmulatorUrl) {
  connectAuthEmulator(auth, authEmulatorUrl);
}
